import {createStore} from 'vuex'

import labels from './modules/store.labels'
import order from './modules/store.order'
import ecom from './modules/store.ecom'
import main from './modules/store.main'
import productSearch from './modules/store.productsearch'
import productDetails from './modules/store.productdetails'
import bulkOrder from './modules/store.bulkorder'


const store = createStore({
    modules: {
        labels,
        order,
        productDetails,
        ecom,
        main,
        productSearch,
        productDetails,
        bulkOrder
    }
})

export default store